/* eslint-disable jsx-a11y/iframe-has-title */
import React, {useCallback, useEffect, useRef} from 'react';
import {
  InteractionLayerSize,
  InteractionLayer,
  Container,
  ContainerWrap,
  ContainerPadding,
  ShimLayer,
} from '@volkswagen-onehub/components-core';
import {IFRAME_SRC, REGISTER_YOUR_INTEREST_MODELS} from './constants';
import {VWCarModel} from '../../types/surveyResponse';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import './RegisterYourInterest.css';
import useMediaQuery from '../../hooks/useMediaQuery';
import {appendQueryParams} from '../../utils';

interface RegisterYourInterestProps {
  activeModel?: string;
  carModel: VWCarModel;
  onClose: () => void;
}

const RegisterYourInterest = ({
  activeModel,
  carModel,
  onClose,
}: RegisterYourInterestProps) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const {isMobile} = useMediaQuery();

  const salesGroupName = REGISTER_YOUR_INTEREST_MODELS[carModel];
  let src = salesGroupName
    ? appendQueryParams(IFRAME_SRC, {
        SalesGroupName: salesGroupName,
      })
    : IFRAME_SRC;

  switch (activeModel) {
    case 'touareg':
      src = appendQueryParams(
        'https://aus.volkswagen.com.au/app/locals/dealer-callback',
        {
          SalesGroupName: 'Touareg-r-phev',
        },
      );
      break;

    default:
      break;
  }

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (activeModel) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeModel, handleClickOutside]);

  return (
    <TransitionGroup>
      <div
        style={{
          position: 'relative',
          zIndex: 3,
        }}
      >
        {activeModel && <ShimLayer key="shim" />}
        <div ref={sidebarRef}>
          <CSSTransition
            in={!!activeModel}
            timeout={300}
            classNames="slide"
            unmountOnExit
          >
            <InteractionLayer size={InteractionLayerSize.E} active>
              <Container
                wrap={ContainerWrap.always}
                padding={ContainerPadding.grid001}
              >
                <iframe
                  src={src}
                  width="100%"
                  style={{
                    border: 'none',
                    marginTop: isMobile ? 64 : 16,
                    height: '100vh',
                  }}
                />
              </Container>
            </InteractionLayer>
          </CSSTransition>
        </div>
      </div>
    </TransitionGroup>
  );
};

export default RegisterYourInterest;
